export default class Model {
  Name: any;

  constructor() {
    this.Name = '';
  }
}